import Route from '@ember/routing/route'

export default class extends Route {
  queryParams = {
    fromSubscriptionType: {
      refreshModel: false,
      replace: true,
    },
    hideEmptyClasses: {
      refreshModel: false,
      replace: true,
    },
    selectedIds: {
      refreshModel: false,
      replace: true,
    },
    teacherId: {
      refreshModel: false,
      replace: true,
    },
  }
}
